import { doc, setDoc, getDoc, serverTimestamp, updateDoc, arrayUnion } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Kullanıcı verilerini Firestore'dan okur
 * @param {string} userId - Firebase Auth'dan gelen user ID
 * @returns {Promise<Object|null>} Kullanıcı verileri veya null
 */
export const getUserData = async (userId) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    
    if (userSnap.exists()) {
      return userSnap.data();
    }
    return null;
  } catch (error) {
    console.error('Error getting user data:', error);
    throw error;
  }
};

/**
 * Yeni kullanıcı kayıt olduğunda Firestore'da user document oluşturur
 * Eğer document zaten varsa hiçbir şey yapmaz (mevcut veriler korunur)
 * @param {string} userId - Firebase Auth'dan gelen user ID
 * @param {string} email - Kullanıcının e-posta adresi
 * @param {string} displayName - Kullanıcının adı (opsiyonel)
 * @param {string} phoneNumber - Kullanıcının telefon numarası (opsiyonel)
 * @param {string} signupSource - Kayıt olma kaynağı ('landing' veya 'checkout')
 */
export const createUserDocument = async (userId, email, displayName = '', phoneNumber = '', signupSource = 'landing') => {
  try {
    const userRef = doc(db, 'users', userId);
    
    // Document zaten var mı kontrol et
    const userSnap = await getDoc(userRef);
    
    if (userSnap.exists()) {
      // Document zaten varsa hiçbir şey yapma (mevcut veriler korunur)
      return;
    }
    
    // Yeni document oluştur
    await setDoc(userRef, {
      isPremium: false,
      email: email,
      displayName: displayName || '',
      phoneNumber: phoneNumber || '', // Optional
      signupSource: signupSource || 'landing', // Kayıt olma kaynağı
      createdAt: serverTimestamp(),
      completedLessons: [],
      lastWatchedVideo: null
    });
    
    console.log('User document created successfully with signupSource:', signupSource);
  } catch (error) {
    console.error('Error creating user document:', error);
    throw error;
  }
};

/**
 * Kullanıcının son izlediği videoyu günceller
 * @param {string} userId - Firebase Auth'dan gelen user ID
 * @param {string} lessonId - İzlenen lesson'un ID'si
 * @param {number} sectionId - Lesson'un bulunduğu section ID'si
 * @param {number} position - Video pozisyonu (saniye cinsinden)
 */
export const updateLastWatchedVideo = async (userId, lessonId, sectionId, position = 0) => {
  try {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      lastWatchedVideo: {
        lessonId: lessonId,
        sectionId: sectionId,
        position: position,
        updatedAt: serverTimestamp()
      }
    });
  } catch (error) {
    console.error('Error updating last watched video:', error);
    // Hata olsa bile uygulama çalışmaya devam etsin
  }
};

/**
 * Kullanıcının tamamladığı ders listesine yeni bir lesson ekler
 * @param {string} userId
 * @param {string} lessonId
 */
export const addCompletedLesson = async (userId, lessonId) => {
  try {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      completedLessons: arrayUnion(lessonId)
    });
  } catch (error) {
    console.error('Error adding completed lesson:', error);
    // Sessizce devam et
  }
};

